export default "__VITE_ASSET__B1O3w7DU__"